import axios from "axios";

const API_URL = "/api/schools";

export const setupSchool = async (data) => {
  const response = await axios.post(`${API_URL}/setup`, data);
  return response.data;
};

export const getSetupStatus = async (schoolId) => {
  const response = await axios.get(`${API_URL}/${schoolId}/status`);
  return response.data;
};

export const getSchools = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const updateSchool = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

// Plans
export const getPlans = async () => {
  const response = await axios.get("/api/plans");
  return response.data;
};

export const getAllPlans = async () => {
  const response = await axios.get("/api/plans/all");
  return response.data;
};

export const createPlan = async (data) => {
  const response = await axios.post("/api/plans", data);
  return response.data;
};

export const updatePlan = async (id, data) => {
  const response = await axios.put(`/api/plans/${id}`, data);
  return response.data;
};

export const deletePlan = async (id) => {
  const response = await axios.delete(`/api/plans/${id}`);
  return response.data;
};

// Billing
export const createCheckoutSession = async (schoolId, planId, billingCycle) => {
  const response = await axios.post("/api/billing/checkout", { schoolId, planId, billingCycle });
  return response.data;
};

export const getSubscription = async (schoolId) => {
  const response = await axios.get(`/api/billing/subscription/${schoolId}`);
  return response.data;
};

export const getBillingPortalUrl = async (schoolId) => {
  const response = await axios.get(`/api/billing/portal/${schoolId}`);
  return response.data;
};
